import Styled from "styled-components";


export const AuthenticationContainer = Styled.div`
display: flex;
width: 900px;
justify-content: space-between;
margin: 30px auto;
`;


